export default {
  giftCard: [{ rule: 'numeric' }]
};
